import { FormControl } from '@angular/forms';
import { ConditionGroup } from '../../models/filter-group.model';

export const RANGE_DATE_FILTER_TYPES = {
  DeliveryDate: 'delivery date',
  ContractDate: 'contract date',
};

export const OPERATORS_MAPPING_SYMBOL: Record<string, string> = {
  '=': 'Equal',
  '!=': 'Not Equal',
  '<': 'Less Than',
  '>': 'Greater Than',
  combination: 'Combination',
  '=,!=': 'Equal, Not Equal',
};

export const SYMBOLS_MAPPING_OPERATORS: Record<string, string> = {
  Equal: '=',
  'Not Equal': '!=',
  'Less Than': '<',
  'Greater Than': '>',
  Combination: 'combination',
  'Equal, Not Equal': '=,!='
};

export const OPERATORS = {
  EQUAL: 'Equal',
  NOT_EQUAL: 'Not Equal',
  LESS_THAN: 'Less Than',
  GREATER_THAN: 'Greater Than',
  COMBINATION: 'Combination',
};

export const DEFAULT_GROUP: ConditionGroup = {
  logic: 'AND',
  conditions: [
    {
      id: 1,
      field: '',
      operator: OPERATORS.EQUAL,
      value: '',
      servicePartnerControl: new FormControl(''),
      depth: 0,
    },
  ],
  collapsed: false,
  isExpanded: true,
  name: 'Group 1 Notes',
};

export const DATE_FIELDS = [
  'hc_delivery_date',
  'delivery date',
  'hc_eod',
  'actual eod date',
  'hc_eos',
  'actual eos date',
  'contract date',
];

export const HQ_FILTER_CRITERIA_FIELDS = [
  'vas type',
  'vas level',
  'hq contract status',
  'hq contract substatus',
];
export const RU_FILTER_CRITERIA_FIELDS = [
  'ru contract class',
  'ru contract status',
  'ru contract sub status',
];
export const DA_FILTER_CRITERIA_FIELDS = [
  'da_it care plan',
  'da_sw upgrade',
  'da_sw upgrade value',
  'da_sw update',
  'da_sw update value',
];
export const MATERIAL_NO_FIELDS = [
  'material no. (component)',
  'material no. (license)',
  'material no. (system)',
  'material no. (hwid)',
  'material no. (workstation)',
];

export const ALL_FIELDS = [
  { label: 'Material No. (Component)', value: 'Material No (Component)' },
  { label: 'Material No. (License)', value: 'Material No (License)' },
  { label: 'Material No. (System)', value: 'Material No (System)' },
  { label: 'Material No. (HWID)', value: 'Material No (HWID)' },
  { label: 'Material No. (Workstation)', value: 'Material No (Workstation)' },
  { label: 'Country', value: 'country' },
  { label: 'Serial No.', value: 'Serial No' },
  { label: 'Software Version', value: 'Software Version' },
  { label: 'UI Number', value: 'uinumber' },
  { label: 'License', value: 'license' },
  { label: 'Component', value: 'component' },
  { label: 'Service Partner', value: 'Service Partner' },
  { label: 'Service Partner Type', value: 'Service Partner Type' },
  { label: 'Update Handling Priority', value: 'Update Handling Priority' },
  { label: 'Business Line', value: 'businessline' },
  { label: 'VAS Type', value: 'vastype' },
  { label: 'VAS Level', value: 'vaslevel' },
  { label: 'Contract Type', value: 'Contract Type' },
  { label: 'Contract Status', value: 'Contract Status' },
  { label: 'Sys IVK', value: 'sysivk' },
  { label: 'RUH Ready', value: 'ruhready' },
  { label: 'Refurbished', value: 'refurbished' },
  { label: 'ASU Enabled', value: 'asuenabled' },
  { label: 'Delivery Date', value: 'Delivery Date' },
  { label: 'Actual EOD Date', value: 'HC_EOD' },
  { label: 'Actual EOS Date', value: 'HC_EOS' },
  { label: 'EQ Status', value: 'EQ Status' },
  { label: 'EQ Substatus', value: 'EQ Substatus' },
  { label: 'RUH Ready Flag', value: 'RUH Ready Flag' },
  { label: 'DA_SW Upgrade', value: 'DA_SW Upgrade' },
  { label: 'DA_SW Update', value: 'DA_SW Update' },
  { label: 'DA_SW Upgrade Value', value: 'DA_SW Upgrade Value' },
  { label: 'DA_SW Update Value', value: 'DA_SW Update Value' },
  { label: 'DA_IT Care Plan', value: 'DA_IT Care Plan' },
  { label: 'RU Contract Class', value: 'RU Contract Class' },
  { label: 'RU Contract Status', value: 'RU Contract Status' },
  { label: 'RU Contract Sub Status', value: 'RU Contract Sub Status' },
  { label: 'Contract Date', value: 'Contract Date' },
  { label: 'RUH Not Allowed by Customer', value: 'RUH Not Allowed by Customer' },
  { label: 'ASU Ready Flag', value: 'ASU Ready Flag' },
  { label: 'ASU Not Allowed by Customer', value: 'ASU Not Allowed by Customer' },
  { label: 'HQ Contract Status', value: 'HQ Contract Status' },
  { label: 'HQ Contract Substatus', value: 'HQ Contract Substatus' },
  { label: 'Service Provider Type', value: 'Service Provider Type' },
  { label: 'RSWD Environment', value: 'RSWD Environment' },
  { label: 'Inhouse Flag', value: 'Inhouse Flag' },
  { label: 'Refurbished / Reconditioned', value: 'Refurbished / Reconditioned' },
  { label: 'Demo Flag', value: 'Demo Flag' },
  { label: 'EQ Solution Flag', value: 'EQ Solution Flag' },
  { label: 'EoS Flag', value: 'EoS Flag' },
  { label: 'CTH Flag', value: 'CTH Flag' },
  { label: 'ES Flag', value: 'ES Flag' },
  { label: 'Embargo Flag', value: 'Embargo Flag' },
  { label: 'SAP Update Status', value: 'SAP Update Status' },
];

export const EQ_SUBSTATUS_OPTIONS = [
  'HW-Change', 'Expired', 'WIPE_PENDING', 'returned', 'on stock', 'unknown',
  'hw-change', 'shipped', 'expired', 'Scrapped', 'Returned', 'WIPED',
  'License Move', 'On Stock', 'active', 'scrapped', 'EVOLVE',
  'Location Unknown', 'evolve', 'location unknown',
];

export const EQ_STATUS_OPTIONS = ['active', 'inactive'];

export const SERVICE_PARTNER_TYPE_OPTIONS: { id: string; name: string }[] = [
  { id: 'C', name: 'SHS Country Organization' },
  { id: 'P', name: 'Business Partner' },
  { id: 'O', name: 'OEM Partner' },
  { id: 'I', name: 'SHS Internal Partner' },
];

export const FIELD_VALUE_OPTIONS: { [key: string]: string[] } = {
  'contract status': ['active', 'cancelled', 'inactive'],
  'sys ivk': ['N', 'J'],
  'ruh ready': ['true', 'false'],
  refurbished: ['Yes', 'No'],
  'asu enabled': ['true', 'false'],
  'ruh ready flag': ['t', 'f'],
  'da_sw upgrade': ['T', 'F'],
  'da_sw update': ['T', 'F'],
  'da_sw upgrade value': [
    'Full system',
    'Software distribution is covered by the service contract',
    'Software distribution and remote installation service is covered by the service contract',
    'Software distribution, remote installation, service and training is covered by the service contract',
    'Software and onsite installation service is covered by the service contract',
  ],
  'da_sw update value': [
    'Software and onsite installation service is covered by service contract',
    'Software distribution, remote installation, service and training is covered by service contract',
    'Software distribution and remote installation service is covered by the service contract',
    'Software distribution is covered by the service contract',
    'Software distribution, remote installation, service and training is covered by the service contract',
  ],
  'da_it care plan': ['No Contract', 'TOP Type', 'Warranty', 'PRO Type', 'Service Package syngo.via Excel', 'Others'],
  'ru contract status': ['active', 'inactive', 'cancelled'],
  'ru contract sub status': [
    'Other',
    'dismantling',
    'active',
    'No Support wanted. Cust will take risk',
    'Customer Buyout',
    'Scrapped',
    'not running',
    'New Contract',
    'End of business',
    'expired',
    'cancelled',
    'New System & Service with Siemens',
  ],
  'ruh not allowed by customer': ['t', 'f'],
  'asu ready flag': ['Y', 'N'],
  'asu not allowed by customer': ['Y', 'N'],
  'hq contract status': ['active', 'inactive', 'cancelled'],
  'hq contract substatus': [
    'Changes to Cost carriers',
    'Customer Buyout',
    'End of Term',
    'Other',
    'No Support wanted. Cust will take risk',
    'active',
    'refused',
    'Scrapped',
    'New Contract',
    'billing block',
    'cancelled',
    'Status Explan.',
    'End of business',
    'Exchange (Follow-up contract?)',
    'Cancel for refinance - New Op Lease',
    'New Owner',
    'Plant sold (Operator Change)',
    'not running',
    'expired',
    'deleted',
    'dismantling',
    '3rd party service',
    'New System & Service with Siemens',
    'terminated',
  ],
  'service partner type': ['P', 'O', 'I', 'C'],
  'update handling priority': ['l', 'm', 'h'],
  'service provider type': ['ISO', 'TEST_SITE', 'ISM', 'DEMO', 'ES', 'N', 'IN_HOUSE', 'SP', 'LOANER'],
  'rswd environment': ['CLASSIC', 'NUCLEUS', 'NG'],
  'inhouse flag': ['P'],
  'refurbished / reconditioned': ['N', 'X', 'Y', 'R'],
  'demo flag': ['Y', 'N'],
  'eq solution flag': ['Y', 'N'],
  'eos flag': ['Y', 'N'],
  'cth flag': ['Y', 'N'],
  'es flag': ['Y', 'N'],
  'embargo flag': ['t', 'f'],
  'sap update status': [
    'ESC1', 'ESC2', 'ESC3', 'OPEN', 'PERF', 'CANC', 'FADE', 'HOLD', 'NOAF',
    'NOAP', 'REPL', 'CINF', 'CREF', 'UNIN', 'RREF', 'RINF', 'RPER', 'RFAI',
    'ROPE', 'OEMP', 'COST', 'DELE', 'DERR', 'INAC', 'RETG', 'SCRP', 'UNKN',
    'COHO', 'POHO', 'RIST', 'RPUB', 'RTRA',
  ],
};

export const SINGLE_VALUE_FIELDS = [
  'asu status',
  'ep update number',
  'equipment number hq',
  'functional location',
  'f/l name 2',
  'f/l name 1',
  'f/l street',
  'f/l postal code',
  'f/l city',
  'f/l country',
  'gtin',
  'hardware version',
  'sap contract no',
  'sap status',
  'service partner name',
  'service partner type description',
  'service partner type',
  'sp responsible for country',
  'srs status',
  'subclass 1',
  'subclass 2',
  'subclass 3',
  'subclass 4',
  'subclass 5',
  'subclass 6',
  'sw change update no',
  'technical ident',
  'update handling priority',
  'update number',
  'update project id',
  'update project name',
];

export const TEXT_FIELDS = [
  'material no. (component)',
  'material no. (license)',
  'material no. (system)',
  'material no. (hwid)',
  'material no. (workstation)',
  'serial no.',
  'software version',
  'ui number',
  'license',
  'component',
  'service partner country',
];

export const BACKEND_MAPPING_FIELDS: { [key: string]: string } = {
  country: 'Country',
  Country: 'Country',
  serialno: 'Serial No.',
  SerialNo: 'Serial No.',
  materialno_hccomponent: 'Material No. (Component)',
  MaterialNo_hccomponent: 'Material No. (Component)',
  'Material No_hccomponent': 'Material No. (Component)',
  materialno_hclicense: 'Material No. (License)',
  MaterialNo_hclicense: 'Material No. (License)',
  'Material No (License)': 'Material No. (License)',
  materialno_hcsystem: 'Material No. (System)',
  MaterialNo_hcsystem: 'Material No. (System)',
  'Material No (System)': 'Material No. (System)',
  materialno_hchwid: 'Material No. (HWID)',
  MaterialNo_hchwid: 'Material No. (HWID)',
  'Material No (HWID)': 'Material No. (HWID)',
  materialno_hcworkstation: 'Material No. (Workstation)',
  MaterialNo_hcworkstation: 'Material No. (Workstation)',
  'Material No (Workstation)': 'Material No. (Workstation)',
  version: 'Software Version',
  'Software version': 'Software Version',
  uinumber: 'UI Number',
  UiNumber: 'UI Number',
  license: 'License',
  License: 'License',
  component: 'Component',
  Component: 'Component',
  refurbished: 'Refurbished',
  Refurbished: 'Refurbished',
  asuenabled: 'ASU Enabled',
  AsuEnabled: 'ASU Enabled',
  servicePartner: 'Service Partner',
  'Service Partner': 'Service Partner',
  servicepartnertype: 'Service Partner Type',
  EQ_SERVICE_PARTNER_TYPE: 'Service Partner Type',
  'Service Partner Type': 'Service Partner Type',
  businessline: 'Business Line',
  BusinessLine: 'Business Line',
  vastype: 'VAS Type',
  VASType: 'VAS Type',
  HC_VAS_TYPE: 'VAS Type',
  vaslevel: 'VAS Level',
  VASLevel: 'VAS Level',
  HQC_VAS_LEVEL: 'VAS Level',
  category: 'Contract Type',
  'Contract Type': 'Contract Type',
  ruhready: 'RUH Ready',
  'RUH ready': 'RUH Ready',
  sysivk: 'Sys IVK',
  SysIVK: 'Sys IVK',
  contractstatus: 'Contract Status',
  'Contract Status': 'Contract Status',
  deliverydate: 'Delivery Date',
  DeliveryDate: 'Delivery Date',
  HC_DELIVERY_DATE: 'Delivery Date',
  actualeoddate: 'Actual EOD Date',
  ActualEODDate: 'Actual EOD Date',
  HC_EOD: 'Actual EOD Date',
  actualeosdate: 'Actual EOS Date',
  ActualEOSDate: 'Actual EOS Date',
  HC_EOS: 'Actual EOS Date',
  STATUS: 'EQ Status',
  status: 'EQ Status',
  cistatus: 'EQ Status',
  CISTATUS: 'EQ Status',
  'EQ Status': 'EQ Status',
  substatus: 'EQ Substatus',
  SUBSTATUS: 'EQ Substatus',
  cisubstatus: 'EQ Substatus',
  CISUBSTATUS: 'EQ Substatus',
  'EQ Substatus': 'EQ Substatus',
  UP_CI_STATUS: 'SAP Update Status',
  'SAP Update Status': 'SAP Update Status',
};

export const FILTER_DROPDOWN_FIELDS: string[] = [
  'contract type',
  'contract status',
  'ruh ready',
  'refurbished',
  'asu enabled',
  'sys ivk',
  'da_it care plan',
];

export const FILTER_MULTISELECT_FIELDS: string[] = [
  'business line',
  'vas type',
  'vas level',
  'eq status',
  'eq substatus',
  'country',
  'ruh ready flag',
  'ruh not allowed by customer',
  'asu ready flag',
  'asu not allowed by customer',
  'ru contract status',
  'ru contract sub status',
  'da_sw upgrade',
  'da_sw upgrade value',
  'da_sw update',
  'da_sw update value',
  'hq contract status',
  'hq contract substatus',
  'service partner type',
  'update handling priority',
  'service provider type',
  'rswd environment',
  'inhouse flag',
  'refurbished / reconditioned',
  'demo flag',
  'eq solution flag',
  'eos flag',
  'cth flag',
  'es flag',
  'embargo flag',
  'sap update status',
];

export const FILTER_SERVICE_PARTNER_FIELD = 'service partner';
export const FIELD_ALIASES = {
  materialnohccomponent: [
    'material no (component)',
    'material no. (component)',
    'eq_mat_id_hccomponent',
  ],
  materialnohclicense: [
    'material no (license)',
    'material no. (license)',
    'eq_mat_id_hclicense',
  ],
  materialnohcsystem: [
    'material no (system)',
    'material no. (system)',
    'eq_mat_id_hcsystem',
  ],
  materialnohchwid: [
    'material no (hwid)',
    'material no. (hwid)',
    'eq_mat_id_hchwid',
  ],
  materialnohcworkstation: [
    'material no (workstation)',
    'material no. (workstation)',
    'eq_mat_id_hcworkstation',
  ],
  country: ['country', 'eq_country_id', 'hc_country'],
  serialno: ['serial no', 'serial no.', 'serial number', 'eq_serial_id'],
  version: ['software version', 'sw version', 'version', 'eq_sw_vs'],
  uinumber: ['ui number', 'ui no', 'equipment no', 'equipment number', 'eq_id'],
  servicepartner: [
    'service partner',
    'operator',
    'eq_service_partner_id',
    'sp',
  ],
  businessline: ['business line', 'level_bl_text'],
  vastype: ['vas type', 'hc_vas_type'],
  vaslevel: ['vas level', 'hqc_vas_level'],
  category: ['contract type', 'contract_type', 'category'],
  contractstatus: ['contract status', 'contract_status'],
  sysivk: ['sys ivk', 'hc_ivk_system'],
  ruhready: ['ruh ready', 'ruh-ready', 'eq_ruh_flg', 'ruh_ready_flag_source'],
  refurbished: ['refurbished', 'eq_refurb_flg'],
  asuenabled: ['asu enabled', 'eq_asu_flg', 'asu'],
  hcdeliverydate: ['delivery date', 'eq_delivery_dt', 'hc_delivery_date'],
  hceod: ['actual eod date', 'eq_eod_dt', 'hc_eod'],
  hceos: ['actual eos date', 'eq_eos_dt', 'hc_eos'],
  cistatus: [
    'ci status',
    'cistatus',
    'status',
    'istatus',
    'eq_status',
    'eq status',
    'eqstatus',
  ],
  cisubstatus: [
    'ci substatus',
    'cisubstatus',
    'substatus',
    'hc_status',
    'hcstatus',
    'eq_sub_status',
    'eq substatus',
    'eqsubstatus',
  ],
  servicepartnertype: ['service partner type', 'eq_service_partner_type'],
  rucontractclass: ['ru contract class', 'eq_con_name'],
  rucontractstatus: ['ru contract status', 'con_ru_status'],
  rucontractsubstatus: ['ru contract sub status', 'con_ru_sub_status'],
  daitcareplan: ['da_it care plan', 'itcareplan'],
  daswupgradevalue: ['da_sw upgrade value', 'softupgradeval'],
  daswupdatevalue: ['da_sw update value', 'softupdatesval'],
  contractdate: ['contract date', 'contractstartdate', 'contractenddate'],
  hqcontractstatus: ['hq contract status', 'status'],
  hqcontractsubstatus: ['hq contract substatus', 'hc_status_explanation'],
  serviceprovidertype: ['service provider type', 'eq_service_provider_type'],
  rswdenvironment: ['rswd environment', 'eq_ruh_ready_source_flg'],
  inhouseflag: ['inhouse flag', 'eq_inhouse_prod_flg'],
  refurbishedreconditioned: ['refurbished / reconditioned', 'eq_refurb_flg'],
  demoflag: ['demo flag', 'eq_demo_flg'],
  eqsolutionflag: ['eq solution flag', 'eq_solution_flg'],
  eosflag: ['eos flag', 'eq_eos_flg'],
  cthflag: ['cth flag', 'eq_cth_flg'],
  esflag: ['es flag', 'eq_es_flg'],
  embargoflag: ['embargo flag', 'sys_embargo_flg'],
  sapupdatestatus: ['sap update status', 'up_ci_status'],
};

export const BOOLEAN_FIELDS = [
  'asu enabled',
  'asuenabled',
  'ruh ready',
  'ruhready',
];

export const MULTI_SELECT_FIELDS = [
  'ruh ready flag',
  'ruh not allowed by customer',
  'asu ready flag',
  'asu not allowed by customer',
  'ru contract status',
  'ru contract sub status',
  'da_sw upgrade value',
  'da_sw update value',
  'hq contract status',
  'hq contract substatus',
  'service partner type',
  'service provider type',
  'rswd environment',
  'inhouse flag',
  'refurbished / reconditioned',
  'demo flag',
  'eq solution flag',
  'eos flag',
  'cth flag',
  'es flag',
  'embargo flag',
  'sap update status',
];